export default __webpack_public_path__ + "static/media/ico-up-green.44634119.svg";